
<template>
  <v-card class="exhibitors-popup">
    <v-tabs vertical id="expo-book-appointment">
      <!--<div><h4 style="color: #000; margin-top: 10px">Exhibitors</h4></div>-->
      <div class="expo-type-dropdown px-8 py-3">
        <v-select
          v-if="types"
          :items="types"
          :item-text="'TypeName'"
          :item-value="'TypeName'"
          label="Select Exhibitor Type"
          dense
          solo
          height="45px"
          v-model="exhibitorType"
        ></v-select>
      </div>

      <div style="height: 450px; overflow-y: auto; padding-bottom: 50px">
        <v-tab
          v-for="exhibitor in getFilteredExhibitorList"
          :key="'appointment_' + exhibitor.id"
          class="single-tab m-0"
          style="
            height: auto;
            width: 400px;
            text-align: left;
            justify-content: flex-start;
            padding: 8px 30px !important;
          "
          @click="backToExList(false)"
        >
          <!--@mouseleave="exhibitor.isTooltipVisible = false"
            @mouseover="exhibitor.isTooltipVisible = true"-->
          <span class="exhibitors-logo-area left">
            <img
              v-if="exhibitor.Logo"
              v-bind:src="exhibitor.Logo"
              v-bind:alt="exhibitor.Name"
              @error="exhibitor.Logo = ''"
            />
            <span v-else>{{ getInitials(exhibitor.Name) }}</span>
          </span>
          <h6 class="exhibitors-name m-0" style="word-break: break-word">
            {{ exhibitor.Name }}
          </h6>
        </v-tab>
      </div>
      <v-tab-item
        v-for="exhibitor in Exhibitorlist"
        :key="'contacts_' + exhibitor.id"
        transition="scroll-y-transition"
      >
        <v-card flat style="background: transparent">
          <div>
            <!--<h4>
              {{ exhibitor.Name }}
            </h4>-->

            <div
              style="
                height: 523px;
                overflow-y: auto;
                padding: 15px;
                position: relative;
              "
              v-if="exhibitor"
            >
              <div
                id="backToExList"
                v-show="isMobileView"
                style="width: 60px; margin-bottom: 5px"
              >
                <a
                  class="d-flex justify-content-between align-items-center"
                  @click="backToExList(true)"
                  ><img
                    width="20px"
                    src="../assets/Images/chat-assets/back-to-list-dark.svg"
                  /><span style="font-size: 16px">Back</span></a
                >
              </div>
              <div
                class="appointment-company-profile"
                :style="marginTopForModal"
                v-show="exhibitor.isTooltipVisible || true"
              >
                <div class="appointment-company-profile-inner-wrap">
                  <div class="appointment-tooltip-head">
                    <h3 v-if="exhibitor.Name">{{ exhibitor.Name }}</h3>
                  </div>
                  <div
                    :class="
                      exhibitor.FullProfile.length > 120
                        ? 'appointment-tooltip-desc long-profile hide-more'
                        : 'appointment-tooltip-desc'
                    "
                  >
                    <p
                      v-if="exhibitor.FullProfile"
                      v-html="exhibitor.FullProfile"
                    ></p>
                    <!--<div
                      v-if="exhibitor.FullProfile.length > 120"
                      id="btn-more"
                      class="btn-more text-right"
                      @click.stop="toggleProfileMore"
                    >
                      More >>
                    </div>-->
                  </div>
                  <div class="appointment-tooltip-footer">
                    <ul>
                      <li>
                        <a
                          v-if="exhibitor.Email"
                          :href="'mailto:' + exhibitor.Email"
                          >{{ exhibitor.Email }}</a
                        >
                      </li>
                      <li>
                        <a
                          v-if="exhibitor.Phone"
                          :href="'tel:' + exhibitor.Phone"
                          >{{ exhibitor.Phone }}</a
                        >
                      </li>

                      <li>
                        <a
                          v-if="exhibitor.Website"
                          target="_blank"
                          :href="exhibitor.Website"
                          >{{ exhibitor.Website }}</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                v-for="contact in exhibitor.MappedContacts"
                :key="contact.AttendeeId"
                :class="
                  !unpublishedAttendeeList.includes(contact.AttendeeId) &&
                  loggedInUser != contact.AttendeeId
                    ? 'exhibitors-contact d-flex justfy-content-between align-items-center'
                    : ''
                "
              >
                <div
                  v-if="
                    !unpublishedAttendeeList.includes(contact.AttendeeId) &&
                    loggedInUser != contact.AttendeeId
                  "
                  class="ex-contact d-flex justify-content-start"
                >
                  <div class="mr-2 contact-profile-pic">
                    <img
                      v-if="contact.ProfilePictureURL"
                      :src="contact.ProfilePictureURL"
                      alt=""
                      @error="contact.ProfilePictureURL = ''"
                      class="d-flex justify-content-celer align-items-center"
                    />

                    <span
                      v-else
                      class="d-flex justify-content-center align-items-center"
                      >{{ getInitials(contact.Name) }}</span
                    >
                  </div>

                  <div class="contact-details">
                    <h5>{{ contact.Name }}</h5>
                    <h6 v-if="contact.Designation && contact.Company">
                      {{
                        contact.Designation +
                        (contact.Designation && contact.Company ? ", " : "") +
                        contact.Company
                      }}
                    </h6>
                    <h6 v-else-if="contact.Designation">
                      {{ contact.Designation }}
                    </h6>
                    <h6 v-else-if="contact.Company">
                      {{ contact.Company }}
                    </h6>
                  </div>
                </div>
                <div
                  v-if="
                    !unpublishedAttendeeList.includes(contact.AttendeeId) &&
                    loggedInUser != contact.AttendeeId
                  "
                  class="ex-action"
                >
                  <v-btn
                    dark
                    color="#1a73e8"
                    class="btn-schedule-meeting"
                    @click="OpenRequestMeeting(contact)"
                    :loading="requestMeetingLoder"
                  >
                    <span class="mr-3"
                      ><img src="../assets/Images/icons/my-meeting-white.svg"
                    /></span>
                    Request Meeting</v-btn
                  >
                </div>
                <div style="clear: both"></div>
              </div>
            </div>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import jQuery from "jquery";
let $ = jQuery;
import common from "@/common";
import db from "../components/firebaseInit";
import axios from "axios";
import APIs from "@/components/APIInit";
let vm;
export default {
  name: "exhibitors",
  components: {},
  props: {
    Exhibitorlist: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      requestMeetingLoder: false,
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      exhibitorType: "All",
      types: [{ TypeId: 0, TypeName: "All", BackgroundImg: null }],
      unpublishedAttendeeList: [],
      loggedInUser: null,
      marginTopForModal: null,
      isMobileView: false,
    };
  },
  created() {
    vm = this;
    var obj = JSON.parse(window.localStorage["my-app"]);
    vm.loggedInUser = obj.user[0].id;
    //alert("created");
    vm.isMobileView = vm.isMobile();
    $(window).resize(function () {
      vm.isMobileView = vm.isMobile();
      //setTimeout(() => {
      vm.backToExList(true, true);
      //}, 5000);
    });
  },
  computed: {
    getFilteredExhibitorList() {
      if (vm.exhibitorType == "All") {
        return vm.Exhibitorlist;
      } else {
        var result = [];
        result = vm.Exhibitorlist.filter(function (item) {
          let filtered = false;
          if (vm.exhibitorType && vm.exhibitorType.length > 0) {
            if (item.Type) {
              filtered = item.Type.TypeName == vm.exhibitorType.trim();
            }
          }
          return filtered;
        });
        return result;
      }
    },
  },
  watch: {},
  mounted() {
    this.fetchFilteredAttendees();
    this.getExhibitorTypes();
  },
  beforeDestroy() {},
  methods: {
    backToExList(option, forceBack) {
      //alert("option:" + option);
      if (vm.isMobileView || forceBack) {
        //console.log(forceBack);
        if (option) {
          //alert("Back");
          $("#expo-book-appointment .v-slide-group").show();
        } else {
          $("#expo-book-appointment .v-slide-group").hide();
        }
      }
    },
    toggleProfileMore() {
      if ($(".appointment-tooltip-desc.long-profile").hasClass("hide-more")) {
        $(".appointment-tooltip-desc.long-profile").removeClass("hide-more");
        $("#btn-more").html("Less >>");
      } else {
        $(".appointment-tooltip-desc.long-profile").addClass("hide-more");
        $("#btn-more").html("More >>");
      }
    },
    getElementHeight() {
      var divHeight = document.getElementsByClassName("single-tab");
      var selectedDiv;
      var zeroElement;
      divHeight.forEach((element) => {
        if (element.className == "single-tab m-0 v-tab v-tab--active") {
          selectedDiv = element.getClientRects();
        }
      });
      zeroElement = divHeight[0];
      zeroElement = zeroElement.getClientRects();
      var finalValue = selectedDiv[0].y - zeroElement[0].y;

      this.marginTopForModal = "margin-top:" + (finalValue + 20) + "px";
    },
    fetchFilteredAttendees() {
      var obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };

      let rqstData = {};

      rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          search: [],
          filter: [],
          sort: { sortBy: "FirstName", sortOrder: "asc" },
          pagination: {
            Page: 1,
            PageSize: 2000,
          },
          origin: "HIDDEN",
        },
      };
      axios
        .post(APIs.AttendeeSearch, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          responseData.data.result.map((attendee) => {
            if (attendee.IsPublished == false || attendee.HideInList == true) {
              vm.unpublishedAttendeeList.push(attendee.AttendeeId);
            }
          });
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    OpenRequestMeeting(contact) {

      this.requestMeetingLoder = true;
      this.$emit("OpenRequestMeeting", contact);
      setTimeout(() => {
        vm.requestMeetingLoder = false;
      }, 5000);
    },
    getInitials(name) {
      return common.getInitials(name);
    },
    getExhibitorTypes() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docRef;

      docRef = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorTypeList")
        .collection("Types")
        .orderBy("TypeName", "asc");

      docRef
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.types.push({
              TypeId: doc.data().TypeId,
              TypeName: doc.data().TypeName,
              BackgroundImg: doc.data().BackgroundImg,
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.exhibitors-popup {
  box-shadow: unset !important;
}
.exhibitors-popup .exhibitors-contact {
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 10px;
  background: #ffffff;
}
.exhibitors-popup .exhibitors-contact .contact-profile-pic {
  height: 50px !important;
  width: 50px !important;
  border-radius: 50%;
  overflow: hidden;
  background: #dbdbdb;
}
.exhibitors-popup .exhibitors-contact .contact-profile-pic img,
.exhibitors-popup .exhibitors-contact .contact-profile-pic span {
  height: 100% !important;
  width: 100% !important;
  font-size: 24px;
  font-weight: 500;
}
.exhibitors-popup .exhibitors-contact .contact-details {
  width: calc(100% - 60px) !important;
}
.exhibitors-popup .exhibitors-contact .btn-schedule-meeting {
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  padding: 5px 15px;
  margin-bottom: 10px;
}
span.exhibitors-logo-area {
  height: 60px !important;
  width: 100px !important;
  overflow: hidden !important;
  border-radius: 6px !important;
  display: inline-flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-right: 10px;
  border: 1px solid #cbcbcb;
}
span.exhibitors-logo-area span {
  font-size: 60px;
}
.exhibitors-name {
  width: calc(100% - 100px) !important;
}
.contact-details h6 {
  font-size: 15px;
  color: #969696;
  font-weight: 400;
  margin: 0;
}
.exhibitors-popup .v-tabs-slider-wrapper {
  display: none;
}
.exhibitors-popup .v-window {
  padding: 0 !important;
}
.expo-type-dropdown .v-text-field__details {
  display: none !important;
}
.expo-type-dropdown .v-input__slot {
  border: 1px solid #cbcbcb;
  box-shadow: none !important;
}

.appointment-company-profile {
  min-height: 160px;
  max-height: max-content;
  /*width: 95%;
  position: absolute;
  left: 20px;
  top: 50%;
  z-index: 9999;*/
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
  display: block;
  transition: all 0.4s;
  /*transform: translateY(-50%);*/
  margin-top: 9px;
  margin-bottom: 15px;
}

/* .appointment-company-profile:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #8a8a8a;
  bottom: 50%;
  right: 99.1%;
  transform: translateY(50%) rotate(-90deg);
} */
.appointment-company-profile-inner-wrap {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 8px;
}
.single-tab:hover .appointment-company-profile {
  display: block;
  transition: all 0.4s;
}
.appointment-tooltip-head h3 {
  color: #333;
  font-size: 1.375rem;
  font-weight: 600;
}
.appointment-tooltip-desc p {
  color: #333;
  font-weight: 400;
  font-size: 1rem;
  margin-bottom: 10px;
  max-height: 78px;
  overflow: auto;
}
.appointment-tooltip-desc.long-profile.hide-more p {
  max-height: 78px;
  overflow: auto;
}
.appointment-tooltip-desc.long-profile .btn-more {
  color: #1976d2;
}
.appointment-tooltip-footer ul {
  margin: 0 !important;
  padding: 0 !important;
}
.appointment-tooltip-footer ul li {
  display: block;
  list-style: none;
}
.appointment-tooltip-footer ul li a {
  display: inline-block;
  color: #333;
  font-size: 1rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 5px;
}
.appointment-tooltip-footer ul li:first-child a {
  padding-left: 1.563rem;
  background: url(../assets/Images/envelope.svg) no-repeat left center / 15px;
}
.appointment-tooltip-footer ul li:nth-child(2) a {
  padding-left: 1.563rem;
  background: url(../assets/Images/contact.svg) no-repeat left center / 15px;
}
.appointment-tooltip-footer ul li:last-child a {
  padding-left: 1.563rem;
  background: url(../assets/Images/web.svg) no-repeat left center / 15px;
}

.exhibitors-contact.d-flex .ex-contact {
  width: 60%;
  align-items: center;
}
.exhibitors-contact.d-flex .ex-action {
  width: 40%;
  margin-top: 24px;
  text-align: right;
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .exhibitors-contact {
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-content: space-between;
  }
  .exhibitors-contact.d-flex .ex-contact {
    width: 100%;
    align-items: center;
  }
  .exhibitors-contact.d-flex .ex-action {
    width: 100%;
    margin-top: 24px;
    text-align: right;
  }
}
@media only screen and (max-width: 768px) {
  .exhibitors-contact {
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-content: space-between;
  }
  .exhibitors-contact.d-flex .ex-contact {
    width: 100%;
    align-items: center;
  }
  .exhibitors-contact.d-flex .ex-action {
    width: 100%;
    margin-top: 24px;
    text-align: right;
  }
}
</style>